import Swiper, {Scrollbar} from '../../../../node_modules/swiper/swiper-bundle';
import { Dropdown } from './dropdown.js';

( function ( $ ) {
	var Checkout = {};

	var editProduct = '.js-edit-item';
	var cartContainer = $( document ).find( '#js-selectedItems' );
	var selectedItemsContainer = $( document ).find( '#js-selectedItems--selection' );
	var selectedTotalsContainer = $( document ).find( '#js-selectedTotals' );
	var voucherContainer = $( document ).find( '#js-selectedVoucher' );
	var paymentMethodContainer = $( document ).find( '#js-selectedPaymentMethod' );
	var newsletterContainer = $( document ).find( '#js-selectedNewsletter' );
	var giftContainer = $( document ).find( '#js-selectedGiftwrap' );
	var paymentFieldsContainer = $( document ).find( '#js-paymentFields' );
	var commentContainer = $( document ).find( '#js-selectedComment' );
	var shippingMethodContainer = $( document ).find( '#js-selectedShippingMethod' );
	var scope = $( document ).find( '#js-checkout-content' );
	var totalDesktop = $( document ).find( '#js-checkout-sidebar' );
	var totalMobile = $( document ).find( '#js-checkout-sidebar-mobile' );
	var isDesktop;
	let hideWhenNoZipFields = $( '.js-hidden-nozip' );
	var $upsalesContainer = $( '#js-upsale-products' );
	var $bundlesContainer = $( '#js-bundle-products' );

	Checkout.init = function () {
		isDesktop = true;
		Checkout.moveTotalSummaryContent();
		Checkout.initUpsales();
		Checkout.initBundles();

		// Payment form submit
		var checkoutFormPurchase = $( document ).find( '.template-checkout #esc_purchase' );
		if ( checkoutFormPurchase ) {
			checkoutFormPurchase.off( 'submit' ).on( 'submit', function () {
				var hasError = Checkout.processPaymentFormValidation();

				if ( hasError === false ) {
					return hasError;
				}
			} );
		}

		// Payment form input fields
		var checkoutFormFields = paymentFieldsContainer.find( 'input' );
		if ( checkoutFormFields ) {
			checkoutFormFields.off( 'focus' ).on( 'focus', function () {
				$( this ).removeClass( 'is-invalid' );
			} );
		}

		// Voucher
		var voucherField = $( document ).find( '#js-selectedVoucher #voucher' );
		if ( voucherField ) {
			voucherField.off( 'keydown' ).on( 'keydown', function ( e ) {
				if ( e.keyCode !== 13 ) {
					return;
				}

				e.preventDefault();
				Checkout.voucherProcess( $( this ).parent().next() );
			} );
		}

		var voucherButton = $( document ).find( '#js-selectedVoucher .js-voucher-button' );
		if ( voucherButton ) {
			voucherButton.off( 'click' ).on( 'click', function ( e ) {
				e.preventDefault();
				Checkout.voucherProcess( $( this ) );
			} );
		}

		// Newsletter
		if ( newsletterContainer.find( ':checkbox' ) ) {
			newsletterContainer.find( ':checkbox' ).off( 'change' ).on( 'change', function ( e ) {
				e.preventDefault();
				Checkout.processNewsletter( 'click' );
			} );
		}

		// Gift
		if ( giftContainer.find( ':checkbox' ) ) {
			giftContainer.find( ':checkbox' ).off( 'change' ).on( 'change', function ( e ) {
				e.preventDefault();
				Checkout.processComment( 'click' );
			} );
		}

		// Comment
		if ( commentContainer.find( 'textarea' ) ) {
			commentContainer.find( 'textarea' ).off( 'blur' ).on( 'blur', function ( e ) {
				e.preventDefault();
				Checkout.processComment( 'click' );
			} );
		}

		// Payment Method
		var paymentOptions = $( document ).find( '#js-selectedPaymentMethod :radio' );
		if ( paymentOptions ) {
			paymentOptions.off( 'change' ).on( 'change', function ( e ) {
				e.preventDefault();
				Checkout.processPaymentMethod( paymentMethodContainer );
			} );
		}

		// Shipping Method
		var shippingOptions = $( document ).find( '#js-selectedShippingMethod :radio' );
		if ( shippingOptions ) {
			shippingOptions.off( 'change' ).on( 'change', function ( e ) {
				e.preventDefault();
				Checkout.processShippingMethod( shippingMethodContainer );
			} );
		}

		// Country
		var countryOptions = $( document ).find( '#js-selectedCountry .js-country-item' );
		if ( countryOptions ) {
			countryOptions.off( 'click' ).on( 'click', function ( e ) {
				e.preventDefault();
				Checkout.countryChangeProcess( this.dataset.code, '', false );
			} );
		}

		// State
		var stateOptions = $( document ).find( '#js-selectedState .js-state-item' );
		if ( stateOptions ) {
			stateOptions.off( 'click' ).on( 'click', function ( e ) {
				e.preventDefault();
				Checkout.countryChangeProcess( $( document ).find( '#js-selectedCountry .js-country-item.active' )[0].dataset.code, this.dataset.code, false );
			} );
		}

        var paymentOptionItems = $(document).find('input[type=radio][name=paymentCheckout]');
        paymentOptionItems.off( 'change' ).on( 'change', function () {
			$('.js-payment-item').removeClass('is-selected');
			if ( $(this).is(':checked')) {
				$(this).closest('.js-payment-item').addClass('is-selected');
			}
		});

		// Check if zip code field was clears
		Checkout.hasZipCode();

		// Make sure there's a selected default shipping method
		let selectedShippingMethod = shippingMethodContainer.find( 'input[name="shippingMethod"]:checked' );

		if ( selectedShippingMethod.length === 0 ) {
			shippingMethodContainer.find( 'input[name="shippingMethod"]:first' ).prop( 'checked', true ).trigger( 'change' );
		}

		// Catch Klarna form updates
		let interval = setInterval( () => {
			console.log( 'waiting for window._klarnaCheckout...' );

			if ( typeof window._klarnaCheckout === 'undefined' ) {
				return;
			}

			clearInterval( interval );

			window._klarnaCheckout( function ( api ) {
				api.on( {
					'shipping_address_change': function ( data ) {
						console.log( 'shipping_address_change', data );

						let zipCode = ( data.hasOwnProperty( 'postal_code' ) && data.postal_code ) ? data.postal_code : null;

						if ( zipCode ) {
							$( '#js-zip-code' ).val( zipCode ).trigger( 'change' );
						}

						if ( data.hasOwnProperty( 'email' ) && data.email ) {
							$.ajax( {
								url: '/wp-admin/admin-ajax.php',
								dataType: 'JSON',
								type: 'POST',
								data: {
									action: 'update_cart_abandonment',
									email: data.email,
									zip_code: zipCode,
								},
								error: function ( request ) {
									console.debug( request );
								},
							} );
						}
					},
				} );
			} );
		}, 1000 );
	};

	Checkout.initUpsales = function () {
		var $upsales = selectedItemsContainer.find( 'template#js-upsale-products-template' );
		var $upsalesTimeline = $('#js-upsale-timeline');

		if ( $upsales.length === 0 ) {
			$upsalesContainer.hide();
			if ($upsalesTimeline.length) $upsalesTimeline.hide();
		} else {
			if ($upsalesTimeline.length) $upsalesTimeline.show();
			$upsalesContainer.show()
				.find( '.js-product-thumb-list' )
				.html( $upsales.html() );

                const upsellSlider = document.querySelector('.js-upsell-slider');
                if (!upsellSlider) return;

                Swiper.use([Scrollbar]);
                new Swiper('.js-upsell-slider', {
                    loop: false,
                    slidesPerView: 'auto',
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                    },
                });
		}
	};

	Checkout.initBundles = function () {
		var $bundles = selectedItemsContainer.find( 'template#js-bundle-products-template' );

		if ( $bundles.length === 0 ) {
			$bundlesContainer.hide();
		} else {
			$bundlesContainer
				.show()
				.html( $bundles.html() );
		}
	};

	Checkout.moveTotalSummaryContent = function () {
		if ( !totalDesktop || !totalMobile ) {
			return;
		}

		var currentIsDesktop = matchMedia( 'screen and (min-width: 1024px)' ).matches;
		var appendContent = function ( from, to ) {
			var content = from.children();

			if ( content ) {
				content.detach().appendTo( to );
			}
		};

		if ( isDesktop !== currentIsDesktop ) {
			if ( currentIsDesktop ) {
				appendContent( totalMobile, totalDesktop );
			} else {
				appendContent( totalDesktop, totalMobile );
			}
		}

		isDesktop = currentIsDesktop;
	};

	Checkout.updateHtml = function ( data ) {
		console.log( 'reinit payments' );

		if ( data.totalItems === 0 ) {
			window.location.href = location.pathname;
		} else {
			paymentMethodContainer.html( data.paymentOptions );
			shippingMethodContainer.html( data.shippingOptions );
			paymentFieldsContainer.html( data.payments );
			cartContainer.html( data.basket );
			selectedItemsContainer.html( data.items );
			selectedTotalsContainer.html( data.totals );
			voucherContainer.html( data.voucher );
			Checkout.init();
			window.lazyLoadInstance.update();
			Dropdown.overlayScroll();
			// Update total price in header
			$( '#js-header-total-price' ).text( $( '.js-total-price' ).text() );
		}

		Checkout.showLoader( false );
	};

	Checkout.showLoader = function ( showLoader ) {
		var loader = $( document ).find( '.js-loader' );
		var hiddenClass = 'd-none';

		if ( !loader ) {
			return;
		}

		if ( showLoader ) {
			loader.removeClass( hiddenClass );
		} else {
			loader.addClass( hiddenClass );
		}
	};

	Checkout.validateEmail = function ( email ) {
		//eslint-disable-next-line
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test( email );
	};

	Checkout.processPaymentFormValidation = function () {

		var hasError = false;

		var formFields = [
			'email',
			'phoneNumber',
			'firstName',
			'lastName',
			'address1',
			'city',
			'zipCode',
			'termsAndConditions',
		];

		$.each( formFields, function ( index, field ) {

			var formField = $( '#address_' + field + ':visible' );

			formField.removeClass( 'is-invalid' );

			if ( typeof ( formField.val() ) !== 'undefined' ) {

				if ( !formField.val() ) {
					formField.addClass( 'is-invalid' );
					hasError = true;
				} else if ( field === 'email' ) {
					if ( !Checkout.validateEmail( formField.val() ) ) {
						formField.addClass( 'is-invalid' );
						hasError = true;
					}
				} else if ( field === 'termsAndConditions' ) {
					if ( !formField.is( ':checked' ) ) {
						formField.addClass( 'is-invalid' );
						hasError = true;
					}
				}
			}
		} );


		if ( hasError ) {
			return false;
		}
	};

	Checkout.processItems = function ( el ) {
		if ( !el ) {
			return;
		}

		$.ajax( {
			type: 'GET',
			dataType: 'json',
			url: el.attr( 'href' ) || el.data( 'href' ),
			beforeSend: function () {
				if (el.find('span.spinner-border').length > 0) {
					el.addClass( 'is-loading' );
				} else {
					el.parents( '.item' ).addClass( 'is-processing' );
				}
			},
			success: function ( data ) {
				if ( data.totalItems === 0 || data.items === '' ) {
					window.location.href = location.pathname;
				} else {
					Checkout.updateHtml( data );
					Checkout.initUpsales();
					Checkout.initBundles()
				}
			},
			complete: () => {
				if (el.find('span.spinner-border').length > 0) {
					el.removeClass( 'is-loading' );
				} else {
					el.parents( '.item' ).removeClass( 'is-processing' );
				}
			},
			error: function ( request ) {
				Checkout.showLoader( false );
				console.debug( request );
			},
		} );
	};

	Checkout.processPaymentMethod = function ( wrapper ) {
		var paymentValue = wrapper.find( ':radio:checked' ).val();

		var sendData = $( '#esc_purchase' ).serialize();

		sendData += '&payment_method=' + paymentValue + '&ajax=1';

		console.log( 'processPaymentMethod' );

		$.ajax( {
			dataType: 'JSON',
			type: 'POST',
			data: sendData,
			beforeSend: function () {
				Checkout.showLoader( true );
			},
			success: function ( data ) {
				Checkout.showLoader( false );
				Checkout.updateHtml( data );
			},
			error: function ( error ) {
				console.log( error );
			},
		} );
	}

	// Checkout.processPaymentMethod = function( wrapper ) {
	// 	var paymentValue = wrapper.find( ':radio:checked' ).val();

	//     console.log( 'processPaymentMethod' );

	//     $.ajax( {
	//         url: window.ajaxURL,
	//         dataType: 'JSON',
	//         data: {
	//             action: 'get_payment_method_form',
	//             payment_method: paymentValue,
	//         },
	//         beforeSend: function() {
	//             Checkout.showLoader( true );
	//         },
	//         success: function ( result ) {
	//             Checkout.showLoader( false );
	//             if( result.html ) {
	//                 $( '#js-paymentFields' ).html( result.html );
	//             } else {
	//                 window.location.reload();
	//             }
	//         },
	//         error: function (request) {
	//             Checkout.showLoader( false );
	//             console.debug(request);
	//         },
	//     } );
	// }

	Checkout.voucherProcess = function ( $button ) {
		var sendData = $( '#esc_purchase' ).serialize();
		var buttonName = $button.attr( 'name' );
		var buttonValue = encodeURIComponent( $button.attr( 'value' ) );

		sendData += '&' + buttonName + '=' + buttonValue + '&ajax=1';

		//Update all HTML
		$.ajax( {
			data: sendData,
			type: 'POST',
			dataType: 'JSON',
			beforeSend: function () {
				Checkout.showLoader( true );
			},
			success: function ( data ) {
				Checkout.updateHtml( data );
			},
			error: function ( request ) {
				Checkout.showLoader( false );
				console.debug( request );
			},
		} );
	};

	Checkout.countryChangeProcess = function ( countryCode, state, reloadPage ) {
		console.log( 'countryChangeProcess' );

		var sendData = 'esc_action=esc_change_country';

		if ( !state ) {
			state = '';
		}

		sendData += '&esc_country=' + countryCode + '&ajax=1';
		sendData += '&address[state]=' + state;

		//Update all HTML
		$.ajax( {
			data: sendData,
			type: 'POST',
			dataType: 'JSON',
			beforeSend: function () {
				Checkout.showLoader( true );
			},
			success: function ( data ) {
				if ( reloadPage ) {
					window.location.reload( true );
				} else {
					Checkout.updateHtml( data );
				}
			},
			error: function ( request ) {
				window.location.reload( true );
				console.debug( request );
			},
		} );
	};

	Checkout.processShippingMethod = function ( wrapper ) {

		var shippingValue = wrapper.find( ':radio:checked' ).val();

		var sendData = $( '#esc_purchase' ).serialize();

		sendData += '&shipping_method=' + shippingValue + '&ajax=1';

		console.log( 'processShippingMethod' );

		$.ajax( {
			dataType: 'JSON',
			type: 'POST',
			data: sendData,
			beforeSend: function () {
				Checkout.showLoader( true );
			},
			success: function ( data ) {
				Checkout.updateHtml( data );
			},
			error: function ( request ) {
				Checkout.showLoader( false );
				console.debug( request );
			},
		} );

	};

	Checkout.processComment = function ( action ) {

		console.log( 'send comment' );

		var value = giftContainer.find( ':checkbox:checked' ).length;
		var form = $( '#esc_purchase' );
		var sendData = form.serializeArray();
		var voucher = form.find( '#js-voucher-field button' ).val();

		$.each( sendData, function () {
			if ( this.name === 'voucher' ) {
				this.value = voucher;
			}
		} );

		sendData = $.param( sendData );

		if ( value === 0 ) {
			sendData += '&internalComment[giftwrap]=0';
		}

		sendData += '&submit_comment' + '=' + value + '&ajax=1';

		//Update all HTML
		$.ajax( {
			data: sendData,
			type: 'POST',
			dataType: 'JSON',
			beforeSend: function () {
				Checkout.showLoader( true );
			},
			success: function ( data ) {
				if ( action === 'click' ) {
					Checkout.updateHtml( data );
				}
			},
			error: function ( request ) {
				Checkout.showLoader( false );
				console.debug( request );
			},
		} );
	};

	Checkout.processNewsletter = function ( action ) {
		console.log( 'newsletter' );

		var value = newsletterContainer.find( ':checkbox:checked' ).length;
		var form = $( '#esc_purchase' );
		var sendData = form.serializeArray();
		var voucher = form.find( '#js-voucher-field button' ).val();

		$.each( sendData, function () {
			if ( this.name === 'voucher' ) {
				this.value = voucher;
			}
		} );

		sendData = $.param( sendData );

		if ( value === 0 ) {
			sendData += '&address[newsletter]=0';
		}

		sendData += '&submit_newsletter' + '=' + value + '&ajax=1';

		//Update all HTML
		$.ajax( {
			data: sendData,
			type: 'POST',
			dataType: 'JSON',
			beforeSend: function () {
				Checkout.showLoader( true );
			},
			success: function ( data ) {
				if ( action === 'click' ) {
					Checkout.updateHtml( data );
				}
			},
			error: function ( request ) {
				Checkout.showLoader( false );
				console.debug( request );
			},
		} );
	};

	Checkout.discount = function () {
		$( document ).on( 'click', '.js-add-discount-button', ( event ) => {
			let $addDiscountInput = $( document ).find( '.js-add-discount-input' );
			let $addDiscountVoucher = $( document ).find( '.js-form-voucher' );

			if ( event.preventDefault ) event.preventDefault();
			$( $addDiscountVoucher ).toggleClass( 'd-none' );
			$( $addDiscountInput ).focus();
		} );
	}

	Checkout.hasZipCode = () => {
		let field = $( '#js-zip-code' );

		if ( !field.val() ) {
			hideWhenNoZipFields.attr( 'style', 'display:none!important' );
			scope.addClass( 'has-no-zipcode' );

			return false;

		}

		const isClosedCountry = Checkout.isClosedCountry();

		if ( isClosedCountry ) {
			$( '.js-closed-country' ).addClass( 'd-flex' ).removeClass( 'd-none' );
			hideWhenNoZipFields.attr( 'style', 'display:none!important' );
			scope.addClass( 'has-no-zipcode' );
		} else {
			$( '.js-closed-country' ).removeClass( 'd-flex' ).addClass( 'd-none' );
			hideWhenNoZipFields.removeAttr( 'style' );
			scope.removeClass( 'has-no-zipcode' );
		}

		return !isClosedCountry;
	};

	Checkout.isClosedCountry = () => {
		let zipCode = parseInt( $( '#js-zip-code' ).val() ),
			country = $( '.js-country-item.active' ).data( 'code' ),
			closedCountriesData = JSON.parse( $( '#js-closed-countries-data' ).text() );

		if ( !closedCountriesData ) {
			return;
		}

		return closedCountriesData.filter( closedCountry => closedCountry.centra_country === country )
			.filter( country => country.zip_codes
				.filter( closedCountryZipCode => closedCountryZipCode.start <= zipCode
					&& closedCountryZipCode.end >= zipCode ).length > 0 ).length > 0;
	};

	Checkout.initZipCodeField = () => {
		$( document ).on( 'change', '#js-zip-code', () => {
			if ( !Checkout.hasZipCode() ) {
				return;
			}

			$.ajax( {
				url: '/wp-admin/admin-ajax.php',
				dataType: 'JSON',
				type: 'POST',
				data: {
					action: 'update_zip_code',
					zip_code: $( '#js-zip-code' ).val(),
				},
				beforeSend: function () {
					Checkout.showLoader( true );
					window.CentraCheckout.suspend();
				},
				success: function ( data ) {
					shippingMethodContainer.html( data.data.shippingOptions );
					selectedTotalsContainer.html( data.data.totals );
					paymentFieldsContainer.html( data.data.payments );
					Checkout.init();

					// Update total price in header
					$( '#js-header-total-price' ).text( $( '.js-total-price' ).text() );
				},
				complete: () => {
					Checkout.showLoader( false );
					window.CentraCheckout.resume();
				},
				error: function ( request ) {
					Checkout.showLoader( false );
					console.debug( request );
				},
			} );
		} );
	};

	if ( scope.length > 0 ) {
		$( document ).ready( function () {
			Checkout.init();

			$( document ).on( 'change', 'select.js-upsale-product-size', function () {
				$( this ).parent().find( 'button.js-edit-item' ).attr( 'data-href', $( this ).val() );
			} );

			// Add/Remove product
			$( document ).on( 'click', editProduct, function ( e ) {
				e.preventDefault();
				Checkout.processItems( $( this ) );
			} );
		} );

		$( window ).resize( function () {
			Checkout.moveTotalSummaryContent();
		} );
	}

	Checkout.discount();
	Checkout.initZipCodeField();

	window.Checkout = Checkout;
} )( jQuery );



// WEBPACK FOOTER //
// ./scripts/components/checkout.js